import { ChangeDetectionStrategy, Component, inject, input} from '@angular/core';
import { AbstractFormComponent, FieldDateComponent, FieldNumberComponent, FieldSelectComponent, FieldTextAreaComponent } from '@spike/scaffolds';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormFactoryService } from '../../../shared/services/form-factory.service';
import { OrganizationStoreService } from '../../../organizations/services/organization-store.service';
import { OrganizationListComponent } from "../../../organizations/components/organization-list/organization-list";
import { EntityApiEnum, EtiquetteApiEnum, ModelApiEnum } from 'src/app/config/entity-api.enum';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-equipment-request-form',
  providers:[],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, FieldDateComponent, FieldTextAreaComponent, FieldNumberComponent, FieldSelectComponent, OrganizationListComponent],
  templateUrl: './equipment-request-form.html'
})

export class EquipmentRequestFormComponent extends AbstractFormComponent{
  private readonly formFactory = inject(FormFactoryService);
  public readonly organizationStore = inject(OrganizationStoreService);
  
  isInsert = input.required<boolean>();
  supplierApi = EntityApiEnum.SUPPLIER;
  supplierModelApi = ModelApiEnum.SUPPLIER;
  supplierEtiquetteApi= EtiquetteApiEnum.SUPPLIER;
  supplierForm = this.formFactory.createCommonForm(this.supplierApi);


  get supplierId(){
    return this.form().get('supplierId')!.value;
  }
  get sendDate(){
    return this.form().get('sendDate')!.value;
  }
  get extimatedDeliveryDate(){
    return this.form().get('extimatedDeliveryDate')!.value;
  }
  get deliveryDate(){
    return this.form().get('deliveryDate')!.value;
  }

}
  